export default "__VITE_ASSET__BfY$1Pt8__"